export default __webpack_public_path__ + "static/mobile-banner-4af2bc1aea546c3eb8e5fe8786a040cc.png";